<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Moje indywidualne opinie członka komisji</h2>
		</v-card-title>
		<substantive-evaluation-table/>
	</div>
</template>

<script>
	import SubstantiveEvaluationTable from "./SubstantiveEvaluationTable";

	export default {
		name: "SubstantiveEvaluationList",
		components: {SubstantiveEvaluationTable},
	};
</script>

<style scoped>

</style>
